/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterFunnelIcon20Solid = forwardRef('UiFilterFunnelIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17 2H3a1 1 0 0 0-1 1v2.219c0 .49.239.948.64 1.229L7.288 9.7a1 1 0 0 1 .426.82v6.246a1 1 0 0 0 1.53.848l2.572-1.607a1 1 0 0 0 .47-.848v-4.64a1 1 0 0 1 .426-.819l4.648-3.253A1.5 1.5 0 0 0 18 5.219V3a1 1 0 0 0-1-1Z" })));
});
